import { Stack } from "@similarweb/ui-components/foundations";

import { useCategoriesComparison } from "../../categories-context";

import { MarketingChannelsChannelsOverviewWidget } from "./MarketingChannelsChannelsOverviewWidget";
import { MarketingChannelsChannelTrafficWidget } from "./MarketingChannelsChannelTrafficWidget";
import { MarketingChannelsTrafficShareWidget } from "./MarketingChannelsTrafficShareWidget";
import { MarketingChannelsTrafficVolumesBySourceWidget } from "./MarketingChannelsTrafficVolumesBySourceWidget";
import { useMarketingChannelsQueries } from "./useMarketingChannelsQueries";

export const MarketingChannels = () => {
    const { isComparisonMode, categories } = useCategoriesComparison();
    const { data, isLoading, isError } = useMarketingChannelsQueries({ categories });

    if (!isComparisonMode) {
        const { graph, totals } = data[categories[0].id] ?? {};

        return (
            <Stack
                data-automation="marketing-channels"
                gap="24px"
            >
                <MarketingChannelsTrafficShareWidget
                    isLoading={isLoading}
                    apiData={totals}
                />
                <MarketingChannelsTrafficVolumesBySourceWidget
                    isLoading={isLoading}
                    apiData={graph}
                />
            </Stack>
        );
    }

    return (
        <Stack
            data-automation="marketing-channels"
            gap="24px"
        >
            <MarketingChannelsChannelsOverviewWidget
                isLoading={isLoading}
                isError={isError}
                data={data}
                categories={categories}
            />
            <MarketingChannelsChannelTrafficWidget
                isLoading={isLoading}
                isError={isError}
                data={data}
                categories={categories}
            />
        </Stack>
    );
};
